<template>
  <sh-modal
    label="Recommendation"
    id="assignments-modal"
    modal-height="fit-content"
    modal-width="1100px"
    @modal-closed="closeModalAndClean"
  >
    <div slot="header" style="display: flex; width: 100%">
      <div>
        <sh-text size="header-1">Recommendation</sh-text>
      </div>
    </div>

    <div
      style="display: flex; text-align: left; width: 100%; margin-bottom: 24px"
    >
      <div style="margin-right: 60px">
        <div>
          <sh-text style="text-align: left; font-weight: bold"
            >Review recommendation:
          </sh-text>
          <sh-radio-group style="margin-top: 6px" horizontal="true">
            <sh-radio-button
              label="Accept/Edit"
              :active="action == 'approve'"
              @active-changed="setAcceptRejRec({ e: $event, val: 'approve' })"
            ></sh-radio-button>
            <sh-radio-button
              label="Reject"
              :active="action == 'downgrade'"
              @active-changed="setAcceptRejRec({ e: $event, val: 'downgrade' })"
            ></sh-radio-button>
          </sh-radio-group>
        </div>
      </div>
      <div style="">
        <sh-text style="text-align: left; font-weight: bold"
          >Status: {{ getReviewDescription(status) }}
        </sh-text>
        <sh-text style="text-align: left; margin-top: 12px"
          >{{ description }}
        </sh-text>
        <!-- <sh-text style="text-align: left; margin-top: 12px"
          >Summary: {{ summary }}
        </sh-text> -->
      </div>
    </div>
    <sh-table condensed="true">
      <sh-table-row slot="header">
        <sh-table-head unsortable="true" columns="2">Role</sh-table-head>
        <sh-table-head unsortable="true" columns="4"
          >Current Assignment</sh-table-head
        >
        <sh-table-head unsortable="true" columns="4"
          >Travel Time/Utilization*</sh-table-head
        >
        <sh-table-head unsortable="true" columns="7"
          >New Assignment</sh-table-head
        >
        <sh-table-head unsortable="true" columns="7">Notes</sh-table-head>
        <!-- <sh-table-head unsortable="true" columns="7"></sh-table-head> -->
      </sh-table-row>
      <sh-table-row
        :class="{ diffrentRecCSE: isAssignedPrimaryDiffThanRecommended }"
      >
        <sh-table-cell columns="2">
          <div class="verticalCenterAbsolute">Primary</div>
        </sh-table-cell>
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            <div style="display: flex">
              <sh-text>{{ flAssignedPrimaryName }} </sh-text>
              <sh-icon
                style="margin-left: 5px"
                icon="warning-triangle"
                size="xs"
                id="icon-prm-untrained"
                v-show="isAssignedPrmCSEnotTrained"
              ></sh-icon>
            </div>
          </div>
        </sh-table-cell>
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            {{ flAssignedPrimaryTravTimeUtiliz }}
          </div>
        </sh-table-cell>

        <sh-table-cell columns="7">
          <sh-dropdown
            :disabled="selecteddivision == 'ImagingZone'"
            v-if="action == 'approve'"
            style="width: auto"
            label="New Primary"
            ref="primarySel"
            :value="primary_edit_assignments.nameTravTimeResUtiliz"
          >
            <sh-text style="margin-top: 8px" size="title-1"
              >IVK Trained</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in trainedRegionCSEs"
              :key="'prmDropRec' + index + primary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEprimaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPrimary(item)"
            >
              <!-- :disabled="isCSEprimaryListItemDisabled(item)" -->
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'primary')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
            <sh-divider></sh-divider>

            <sh-text style="margin-top: 8px" size="title-1"
              >RBD Compliant</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in rbdCompliantCSEs"
              :key="'prmDropRecRbd' + index + primary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEprimaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPrimary(item)"
            >
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'primary')"
                >Recommended</sh-text
              >
            </sh-menu-item>
            <sh-divider></sh-divider>

            <sh-text style="margin-top: 8px" size="title-1">Untrained</sh-text>
            <sh-menu-item
              v-for="(item, index) in untrainedRegionCSEs"
              :key="'prmDropRecUn' + index + primary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEprimaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPrimary(item)"
            >
              <!-- :disabled="isCSEprimaryListItemDisabled(item)" -->
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'primary')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
          </sh-dropdown>
          <div
            style="padding-top: 4px; padding-bottom: 4px"
            v-if="action !== 'approve'"
          >
            <div style="float: left">{{ getPrimaryNewAssignName }}</div>
            <div style="float: right">
              {{ getPrimaryNewAssignTimeToTravel }} /
              {{ getPrimaryNewAssignUtil }}%
            </div>
          </div>
          <sh-text></sh-text>
        </sh-table-cell>

        <sh-table-cell columns="7">
          <div v-if="!isAssignedPrimarySameAsSelected && action == 'approve'">
            <sh-dropdown
              mandatory="true"
              style="width: auto"
              label="Reason for not using recommended CSE"
              :value="downgradeReasonPrimary.description"
              ref="downgradeSelector"
            >
              <sh-menu-item
                style="text-align: left"
                v-for="(item, index) in filteredDowngradeOptions"
                :key="index"
                :label="item.description"
                :active="item.description == downgradeReasonPrimary.description"
                @click.prevent="setDowngradeOptionPrimary(index)"
              ></sh-menu-item>
            </sh-dropdown>
            <sh-datepicker
              style="margin-top: 4px"
              format="YYYYMMDD"
              v-for="(item, index) in filteredRequiredDates"
              :key="'dateDisplayed' + index"
              v-show="item.description === downgradeReasonPrimary.description"
              :label="item.date_label"
              :value="dateObj[item.cse_pref_key]"
              @value-changed="changeCSEPreferenceObj($event, item.cse_pref_key)"
            ></sh-datepicker>
            <div
              v-if="isAdditionalCommentMandatoryPrimary"
              style="margin-top: 4px"
            >
              <sh-input-text
                :mandatory="isAdditionalCommentMandatoryPrimary"
                :value="prm_detailed_reason"
                @value-changed="setPrmDetailReason($event)"
                label="Add more details here."
              ></sh-input-text>
            </div>
          </div>
          <div style="display: flex; margin-top: 4px" v-if="isSelPrmNotTrained">
            <sh-icon icon="warning" size="xs"></sh-icon>
            <sh-text size="body-2" style="margin-left: 5px"
              >Selected primary CSE is not trained on this IVK.</sh-text
            >
          </div>
        </sh-table-cell>
      </sh-table-row>
      <sh-table-row
        :class="{ diffrentRecCSE: isAssignedSecondaryDiffThanRecommended }"
      >
        <sh-table-cell columns="2">
          <div class="verticalCenterAbsolute">Secondary</div></sh-table-cell
        >
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            <div>
              <div style="display: flex">
                <sh-text>{{ flAssignedSecondaryName }} </sh-text>
                <sh-icon
                  style="margin-left: 5px"
                  icon="warning-triangle"
                  size="xs"
                  id="icon-sec-untrained"
                  v-show="isAssignedSecCSEnotTrained"
                ></sh-icon>
              </div>
            </div>
          </div>
        </sh-table-cell>
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            {{ flAssignedSecondaryTravTimeUtiliz }}
          </div>
        </sh-table-cell>

        <sh-table-cell columns="7">
          <sh-dropdown
            :disabled="selecteddivision == 'ImagingZone'"
            v-if="action == 'approve'"
            style="width: auto"
            label="New Secondary"
            ref="secondarySel"
            :value="secondary_edit_assignments.nameTravTimeResUtiliz"
          >
            <sh-text style="margin-top: 8px" size="title-1"
              >IVK Trained</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in trainedRegionCSEs"
              :key="'secDropRec' + index + secondary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEsecondaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedSecondary(item)"
            >
              <!-- :disabled="isCSEsecondaryListItemDisabled(item)" -->
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'secondary')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
            <sh-divider></sh-divider>
            <sh-text style="margin-top: 8px" size="title-1"
              >RBD Compliant</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in rbdCompliantCSEs"
              :key="'secDropRecRbd' + index + secondary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEsecondaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedSecondary(item)"
            >
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'secondary')"
                >Recommended</sh-text
              >
            </sh-menu-item>
            <sh-divider></sh-divider>
            <sh-text style="margin-top: 8px" size="title-1">Untrained</sh-text>
            <sh-menu-item
              v-for="(item, index) in untrainedRegionCSEs"
              :key="'secDropRecUn' + index + secondary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEsecondaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedSecondary(item)"
            >
              <!-- :disabled="isCSEsecondaryListItemDisabled(item)" -->
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'secondary')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
          </sh-dropdown>
          <div
            style="padding-top: 4px; padding-bottom: 4px"
            v-if="action !== 'approve'"
          >
            <div style="float: left">{{ getSecondaryNewAssignName }}</div>
            <div style="float: right">
              {{ getSecondaryNewAssignTimeToTravel }} /
              {{ getSecondaryNewAssignUtil }}%
            </div>
          </div>
        </sh-table-cell>
        <sh-table-cell columns="7">
          <div
            style="
              position: absolute;
              top: 50%;
              -ms-transform: translateY(-50%);
              transform: translateY(-50%);
            "
          >
            <div style="display: flex" v-if="isSecondarySameAsPrmTrd">
              <sh-icon icon="warning" size="xs"></sh-icon>
              <sh-text size="body-2" style="margin-left: 5px"
                >Same CSE has been assigned another role.</sh-text
              >
            </div>
            <div
              style="display: flex; margin-top: 4px"
              v-if="isSelSecNotTrained"
            >
              <sh-icon icon="warning" size="xs"></sh-icon>
              <sh-text size="body-2" style="margin-left: 5px"
                >Selected secondary CSE is not trained on this IVK.</sh-text
              >
            </div>
          </div>
        </sh-table-cell>
      </sh-table-row>
      <sh-table-row
        :class="{ diffrentRecCSE: isAssignedTertiaryDiffThanRecommended }"
      >
        <sh-table-cell columns="2">
          <div class="verticalCenterAbsolute">Tertiary</div></sh-table-cell
        >
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            <div>
              <div style="display: flex">
                <sh-text>{{ flAssignedTertiaryName }} </sh-text>
                <sh-icon
                  style="margin-left: 5px"
                  icon="warning-triangle"
                  size="xs"
                  id="icon-trd-untrained"
                  v-show="isAssignedTrdCSEnotTrained"
                ></sh-icon>
              </div>
            </div>
          </div>
        </sh-table-cell>
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            {{ flAssignedTertiaryTravTimeUtiliz }}
          </div>
        </sh-table-cell>
        <sh-table-cell columns="7">
          <sh-dropdown
            :disabled="selecteddivision == 'ImagingZone'"
            v-if="action == 'approve'"
            style="width: auto"
            label="New Tertiary"
            ref="tertiarySel"
            :value="tertiary_edit_assignments.nameTravTimeResUtiliz"
          >
            <sh-text style="margin-top: 8px" size="title-1"
              >IVK Trained</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in trainedRegionCSEs"
              :key="'trdDropRec' + index + tertiary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEtertiaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedTertiary(item)"
            >
              <!-- :disabled="isCSEtertiaryListItemDisabled(item)" -->
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'tertiary')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
            <sh-divider></sh-divider>
            <sh-text style="margin-top: 8px" size="title-1"
              >RBD Compliant</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in rbdCompliantCSEs"
              :key="'trdDropRecRbd' + index + tertiary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEtertiaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedTertiary(item)"
            >
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'tertiary')"
                >Recommended</sh-text
              >
            </sh-menu-item>
            <sh-divider></sh-divider>

            <sh-text style="margin-top: 8px" size="title-1">Untrained</sh-text>
            <sh-menu-item
              v-for="(item, index) in untrainedRegionCSEs"
              :key="'trdDropRecUn' + index + tertiary_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isCSEtertiaryListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedTertiary(item)"
            >
              <!-- :disabled="isCSEtertiaryListItemDisabled(item)" -->
              <sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'tertiary')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
          </sh-dropdown>
          <div
            style="padding-top: 4px; padding-bottom: 4px"
            v-if="action !== 'approve'"
          >
            <div style="float: left">{{ getTertiaryNewAssignName }}</div>
            <div style="float: right">
              {{ getTertiaryNewAssignTimeToTravel }} /
              {{ getTertiaryNewAssignUtil }}%
            </div>
          </div>
        </sh-table-cell>
        <sh-table-cell columns="7">
          <div
            style="
              position: absolute;
              top: 50%;
              -ms-transform: translateY(-50%);
              transform: translateY(-50%);
            "
          >
            <div style="display: flex" v-if="isTertiarySameAsPrmSec">
              <sh-icon icon="warning" size="xs"></sh-icon>
              <sh-text size="body-2" style="margin-left: 5px"
                >Same CSE has been assigned another role.</sh-text
              >
            </div>
            <div
              style="display: flex; margin-top: 4px"
              v-if="isSelTrdNotTrained"
            >
              <sh-icon icon="warning" size="xs"></sh-icon>
              <sh-text size="body-2" style="margin-left: 5px"
                >Selected tertiary CSE is not trained on this IVK.</sh-text
              >
            </div>
          </div>
        </sh-table-cell>
      </sh-table-row>
      <sh-table-row
        :class="{ diffrentRecCSE: isAssignedPmDiffThanRecommended }"
      >
        <sh-table-cell columns="2">
          <div class="verticalCenterAbsolute">PM</div></sh-table-cell
        >
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            <div>
              <div style="display: flex">
                <sh-text>{{ flAssignedPmName }} </sh-text>
                <sh-icon
                  style="margin-left: 5px"
                  icon="warning-triangle"
                  size="xs"
                  id="icon-pm-untrained"
                  v-show="isAssignedPmCSEnotTrained"
                ></sh-icon>
              </div>
            </div>
          </div>
        </sh-table-cell>
        <sh-table-cell columns="4">
          <div class="verticalCenterAbsolute">
            {{ flAssignedPmTravTimeUtiliz }}
          </div>
        </sh-table-cell>
        <sh-table-cell columns="7">
          <sh-dropdown
            v-if="action == 'approve'"
            style="width: auto"
            label="New PM"
            ref="pmSel"
            :value="pm_edit_assignments.nameTravTimeResUtiliz"
          >
            <sh-text style="margin-top: 8px" size="title-1"
              >IVK Trained</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in trainedRegionCSEs"
              :key="'pmDropRec' + index + pm_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isPmListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPM(item)"
              ><sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'pm')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
            <!-- <sh-divider></sh-divider>
            <sh-text style="margin-top: 8px" size="title-1"
              >IVK Trained CSA</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in trainedRegionCSAs"
              :key="'pmCsaDropRec' + index + pm_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isPmListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPM(item)"
              ><sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'pm')"
                >Recommended</sh-text
              >
              <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              >
            </sh-menu-item> -->
            <sh-divider></sh-divider>
            <sh-text style="margin-top: 8px" size="title-1"
              >RBD Compliant</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in rbdCompliantCSEs"
              :key="'pmDropRecRbd' + index + pm_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isPmListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPM(item)"
              ><sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'pm')"
                >Recommended</sh-text
              >
            </sh-menu-item>
            <sh-divider></sh-divider>

            <sh-text style="margin-top: 8px" size="title-1"
              >Untrained</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in untrainedRegionCSEs"
              :key="'pmDropRecUn' + index + pm_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isPmListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPM(item)"
              ><sh-text
                slot="functions"
                color="primary"
                style="width: fit-content; font-weight: bold"
                v-if="isListItemRecommended(item, 'pm')"
                >Recommended</sh-text
              >
              <!-- <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              > -->
            </sh-menu-item>
            <!-- <sh-divider></sh-divider>
            <sh-text style="margin-top: 8px" size="title-1"
              >Untrained CSA</sh-text
            >
            <sh-menu-item
              v-for="(item, index) in untrainedRegionCSAs"
              :key="'pmUnCsaDrop' + index + pm_edit_assignments.Id"
              :label="item.nameTravTimeResUtiliz"
              :active="isPmListItemActive(item)"
              @expand="blockEvent"
              @collapse="blockEvent"
              @click.prevent="callSetSelectedPM(item)"
            >
              <sh-text
                slot="functions"
                color="secondary"
                style="width: fit-content; white-space: nowrap"
                >{{ item.timeToTravel }} / {{ item.ResUtil_Heatmap }}%</sh-text
              >
            </sh-menu-item> -->
          </sh-dropdown>
          <div
            style="padding-top: 4px; padding-bottom: 4px"
            v-if="action !== 'approve'"
          >
            <div style="float: left">{{ getPMNewAssignName }}</div>
            <div style="float: right">
              {{ getPMNewAssignTimeToTravel }} / {{ getPMNewAssignUtil }}%
            </div>
          </div>
        </sh-table-cell>
        <sh-table-cell columns="7">
          <!-- <sh-text
            size="body-2"
            style="color: red; margin-left: 0px; margin-top: 8px"
            v-if="isPmDiffrentThanPrimary"
            >new Pm is not the same as primary</sh-text
          > -->
          <div
            style="
              position: absolute;
              top: 50%;
              -ms-transform: translateY(-50%);
              transform: translateY(-50%);
            "
          >
            <sh-checkbox
              v-if="action == 'approve'"
              label="Same as primary"
              :active="isPMSameAsPrimary"
              @checked="setPmSameAsPrimary($event)"
            ></sh-checkbox>
            <div
              style="display: flex; margin-top: 4px"
              v-if="isSelPmNotTrained"
            >
              <sh-icon icon="warning" size="xs"></sh-icon>
              <sh-text size="body-2" style="margin-left: 5px"
                >Selected PM CSE is not trained on this IVK.</sh-text
              >
            </div>
          </div>
        </sh-table-cell>
      </sh-table-row>
    </sh-table>
    <sh-tooltip
      label="CSE is not trained on this IVK"
      target="icon-prm-untrained"
      placement="right"
      variation="short"
    ></sh-tooltip>
    <sh-tooltip
      label="CSE is not trained on this IVK"
      target="icon-sec-untrained"
      placement="right"
      variation="short"
    ></sh-tooltip>
    <sh-tooltip
      label="CSE is not trained on this IVK"
      target="icon-trd-untrained"
      placement="right"
      variation="short"
    ></sh-tooltip>
    <sh-tooltip
      label="CSE is not trained on this IVK"
      target="icon-pm-untrained"
      placement="right"
      variation="short"
    ></sh-tooltip>

    <div style="margin-top: 24px">
      <sh-text>* Within shift utilization over last 6 months</sh-text>
    </div>
    <div style="display: flex; text-align: left; margin-top: 24px">
      <div>
        <sh-text>Was the recommendation useful? </sh-text>
        <sh-text size="body-2" style="color: red; margin-left: 8px"
          >*Mandatory for submitting</sh-text
        >
      </div>

      <div style="width: 100px; margin-left: 24px">
        <star-rating
          v-model:rating="rating"
          :read-only="status !== 'Review'"
          :star-size="25"
          :show-rating="false"
          @rating-selected="setRating($event)"
        >
        </star-rating>
      </div>
    </div>
    <sh-input-text
      style="margin-top: 24px; margin-bottom: 24px"
      :value="feedback"
      @value-changed="setRecComment($event)"
      textarea
      label="Add more details here. Your feedback would help improve subsequent recommendations."
    ></sh-input-text>
    <!-- <sh-input-text
      v-if="status !== 'Review'"
      :value="feedback"
      readonly
      label="Recommandation comment added by user:"
    ></sh-input-text> -->

    <div class="buttonsFooter">
      <sh-button
        :disabled="submitButonDisabled"
        size="m"
        label="Submit"
        @click="submitSelectedRecommend"
      ></sh-button>
    </div>
  </sh-modal>
</template>
<script>
import StarRating from "vue-star-rating";
import { mapGetters, mapMutations, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "RecommendationAssignments",
  props: {
    selecteddivision: {
      type: String,
      required: true,
    },
    travel_time_map: {
      type: Object,
      required: true,
    },
    zone_travel_time_map: {
      type: Object,
      required: true,
    },
  },
  components: {
    StarRating,
  },
  data() {
    return {
      action: "approve",
      // additional_comment: "",
      // comment: "",
      description: "",
      new_assignments: [],
      rating: null,
      feedback: "",
      downgradeReasonPrimary: {
        description: "",
        id: null,
        name: "",
        enable: null,
        date_required: 0,
        date_label: "",
        cse_pref_key: null,
      },
      prm_detailed_reason: "",
      // downgradeReasonSecondary: {
      //   description: "",
      //   id: null,
      //   name: "",
      //   enable: null,
      //   date_required: 0,
      //   date_label: "",
      //   cse_pref_key: null,
      // },
      // downgradeReasonTertiary: {
      //   description: "",
      //   id: null,
      //   name: "",
      //   enable: null,
      //   date_required: 0,
      //   date_label: "",
      //   cse_pref_key: null,
      // },
      // downgradeReasonPM: {
      //   description: "",
      //   id: null,
      //   name: "",
      //   enable: null,
      //   date_required: 0,
      //   date_label: "",
      //   cse_pref_key: null,
      // },
      selectedDowngradeOptionEmpty: {
        description: "",
        id: null,
        name: "",
        enable: null,
        date_required: 0,
        date_label: "",
        cse_pref_key: null,
      },
      status: "",
      summary: "",
      time: "",
      uid: "",
      dateObj: {},
      trainedRegionCSEs: [],
      rbdCompliantCSEs: [],
      untrainedRegionCSEs: [],
      trainedRegionCSAs: [],
      untrainedRegionCSAs: [],
      primary_edit_assignments: {
        Id: "",
        Name: "",
        nameTravTimeResUtiliz: "",
      },
      secondary_edit_assignments: {
        Id: "",
        Name: "",
        nameTravTimeResUtiliz: "",
      },
      tertiary_edit_assignments: {
        Id: "",
        Name: "",
        nameTravTimeResUtiliz: "",
      },
      pm_edit_assignments: {
        Id: "",
        Name: "",
        nameTravTimeResUtiliz: "",
      },
      empty_edit_assignments: {
        Id: "",
        Name: "",
        nameTravTimeResUtiliz: "",
      },
      isPMSameAsPrimary: true,
    };
  },
  computed: {
    ...mapGetters([
      "selectedRecommandationIndex",
      "filteredRecommend",
      "backendURL",
      "getReviewDescription",
      "fl_cse_conn_obj",
      "cse_static",
      "csa_static",
      "fl_static",
      "downgradeOptions",
      "selectedCountry",
    ]),
    ...mapGetters("oidcStore", ["oidcUser"]),
    flAssignedPmName: function () {
      return this.getAssignedRoleName(
        "PMCSEID",
        this.callGetAssignedField,
        this.getAssignedCSEorCSAfield
      );
    },
    flAssignedPmTravTimeUtiliz: function () {
      if (this.new_assignments.length !== 0) {
        let travelTime = this.findTimeToTravelByCSELabel("PMCSEID");
        let resUtiliz = this.getAssignedCSEorCSAfield(
          "PMCSEID",
          this.new_assignments[0].FLID,
          "ResUtil_Heatmap"
        );
        if (travelTime || resUtiliz) {
          return travelTime + " / " + resUtiliz + "%";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    flAssignedPmId: function () {
      return this.callGetAssignedField(
        "PMCSEID",
        "Id",
        this.getAssignedCSEorCSAfield
      );
    },
    flRecommendedPmId: function () {
      return this.getNewAssignCSEField("pm", "Id");
    },
    flAssignedPrimaryName: function () {
      return this.getAssignedRoleName(
        "PrimaryCSEID",
        this.callGetAssignedField,
        this.getAssignedCSEField
      );
    },
    flAssignedPrimaryTravTimeUtiliz: function () {
      if (this.new_assignments.length !== 0) {
        let travelTime = this.findTimeToTravelByCSELabel("PrimaryCSEID");
        let resUtiliz = this.callGetAssignedField(
          "PrimaryCSEID",
          "ResUtil_Heatmap",
          this.getAssignedCSEField
        );
        if (travelTime || resUtiliz) {
          return travelTime + " / " + resUtiliz + "%";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    flAssignedPrimaryId: function () {
      return this.callGetAssignedField(
        "PrimaryCSEID",
        "Id",
        this.getAssignedCSEField
      );
    },
    flRecommendedPrimaryId: function () {
      return this.getNewAssignCSEField("primary", "Id");
    },
    flAssignedSecondaryName: function () {
      return this.getAssignedRoleName(
        "SecondaryCSEID",
        this.callGetAssignedField,
        this.getAssignedCSEField
      );
    },
    flAssignedSecondaryTravTimeUtiliz: function () {
      if (this.new_assignments.length !== 0) {
        let travelTime = this.findTimeToTravelByCSELabel("SecondaryCSEID");
        let resUtiliz = this.callGetAssignedField(
          "SecondaryCSEID",
          "ResUtil_Heatmap",
          this.getAssignedCSEField
        );
        if (travelTime || resUtiliz) {
          return travelTime + " / " + resUtiliz + "%";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    flAssignedSecondaryId: function () {
      return this.callGetAssignedField(
        "SecondaryCSEID",
        "Id",
        this.getAssignedCSEField
      );
    },
    flRecommendedSecondaryId: function () {
      return this.getNewAssignCSEField("secondary", "Id");
    },
    flAssignedTertiaryName: function () {
      return this.getAssignedRoleName(
        "TertiaryCSEID",
        this.callGetAssignedField,
        this.getAssignedCSEField
      );
    },
    flAssignedTertiaryTravTimeUtiliz: function () {
      if (this.new_assignments.length !== 0) {
        let travelTime = this.findTimeToTravelByCSELabel("TertiaryCSEID");
        let resUtiliz = this.callGetAssignedField(
          "TertiaryCSEID",
          "ResUtil_Heatmap",
          this.getAssignedCSEField
        );
        if (travelTime || resUtiliz) {
          return travelTime + " / " + resUtiliz + "%";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    flAssignedTertiaryId: function () {
      return this.callGetAssignedField(
        "TertiaryCSEID",
        "Id",
        this.getAssignedCSEField
      );
    },
    flRecommendedTeriaryId: function () {
      return this.getNewAssignCSEField("tertiary", "Id");
    },
    isAssignedPrimarySameAsSelected: function () {
      if (this.new_assignments.length !== 0) {
        let prmIndex = this.new_assignments.findIndex(
          (assignment) => assignment.AssignmentType === "primary"
        );
        if (prmIndex !== -1) {
          if (
            this.new_assignments[prmIndex].CSEID ===
            this.primary_edit_assignments.Id
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    // isPmDiffrentThanPrimary: function () {
    //   if (this.pm_edit_assignments.Id == this.primary_edit_assignments.Id) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },

    isSecondarySameAsPrmTrd: function () {
      let trainedNotAsigned = this.trainedRegionCSEs.filter(
        (obj) =>
          obj.Id != this.primary_edit_assignments.Id &&
          obj.Id != this.secondary_edit_assignments.Id &&
          obj.Id != this.tertiary_edit_assignments.Id
      );
      if (
        this.secondary_edit_assignments.Id &&
        (this.secondary_edit_assignments.Id ==
          this.primary_edit_assignments.Id ||
          this.secondary_edit_assignments.Id ==
            this.tertiary_edit_assignments.Id) &&
        trainedNotAsigned.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    isTertiarySameAsPrmSec: function () {
      let trainedNotAsigned = this.trainedRegionCSEs.filter(
        (obj) =>
          obj.Id != this.primary_edit_assignments.Id &&
          obj.Id != this.secondary_edit_assignments.Id &&
          obj.Id != this.tertiary_edit_assignments.Id
      );
      if (
        this.tertiary_edit_assignments.Id &&
        (this.tertiary_edit_assignments.Id ==
          this.primary_edit_assignments.Id ||
          this.tertiary_edit_assignments.Id ==
            this.secondary_edit_assignments.Id) &&
        trainedNotAsigned.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    isAssignedPrimaryDiffThanRecommended: function () {
      return this.flAssignedPrimaryId !== this.flRecommendedPrimaryId;
    },

    isAssignedSecondaryDiffThanRecommended: function () {
      return this.flAssignedSecondaryId !== this.flRecommendedSecondaryId;
    },

    isAssignedTertiaryDiffThanRecommended: function () {
      return this.flAssignedTertiaryId !== this.flRecommendedTeriaryId;
    },

    isAssignedPmDiffThanRecommended: function () {
      return this.flAssignedPmId !== this.flRecommendedPmId;
    },

    isSelPrmNotTrained: function () {
      if (this.primary_edit_assignments.Id) {
        let prmIdxInTrained = this.trainedRegionCSEs.findIndex(
          (obj) => obj.Id == this.primary_edit_assignments.Id
        );
        if (prmIdxInTrained == -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isSelSecNotTrained: function () {
      if (this.secondary_edit_assignments.Id) {
        let secIdxInTrained = this.trainedRegionCSEs.findIndex(
          (obj) => obj.Id == this.secondary_edit_assignments.Id
        );
        if (secIdxInTrained == -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isSelTrdNotTrained: function () {
      if (this.tertiary_edit_assignments.Id) {
        let trdIdxInTrained = this.trainedRegionCSEs.findIndex(
          (obj) => obj.Id == this.tertiary_edit_assignments.Id
        );
        if (trdIdxInTrained == -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isSelPmNotTrained: function () {
      if (this.pm_edit_assignments.Id) {
        let pmIdxInTraineCSEs = this.trainedRegionCSEs.findIndex(
          (obj) => obj.Id == this.pm_edit_assignments.Id
        );
        let pmIdxInTraineCSAs = this.trainedRegionCSAs.findIndex(
          (obj) => obj.Id == this.pm_edit_assignments.Id
        );
        if (pmIdxInTraineCSEs == -1 && pmIdxInTraineCSAs == -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    isAdditionalCommentMandatoryPrimary: function () {
      if (
        this.downgradeReasonPrimary.description ==
        "Other (explained in comment box)"
      ) {
        return true;
      } else {
        return false;
      }
    },

    isAssignedPrmCSEnotTrained: function () {
      if (this.new_assignments.length !== 0) {
        let prmId = this.getAssignedCSEField(
          "PrimaryCSEID",
          this.new_assignments[0].FLID,
          "Id"
        );
        if (prmId) {
          let prmIdxInTrained = this.trainedRegionCSEs.findIndex(
            (obj) => obj.Id == prmId
          );
          if (prmIdxInTrained == -1) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },

    isAssignedSecCSEnotTrained: function () {
      if (this.new_assignments.length !== 0) {
        let secId = this.getAssignedCSEField(
          "SecondaryCSEID",
          this.new_assignments[0].FLID,
          "Id"
        );
        if (secId) {
          let secIdxInTrained = this.trainedRegionCSEs.findIndex(
            (obj) => obj.Id == secId
          );
          if (secIdxInTrained == -1) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },

    isAssignedTrdCSEnotTrained: function () {
      if (this.new_assignments.length !== 0) {
        let trdId = this.getAssignedCSEField(
          "TertiaryCSEID",
          this.new_assignments[0].FLID,
          "Id"
        );
        if (trdId) {
          let trdIdxInTrained = this.trainedRegionCSEs.findIndex(
            (obj) => obj.Id == trdId
          );
          if (trdIdxInTrained == -1) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },

    isAssignedPmCSEnotTrained: function () {
      if (this.new_assignments.length !== 0) {
        let pmId = this.getAssignedCSEorCSAfield(
          "PMCSEID",
          this.new_assignments[0].FLID,
          "Id"
        );
        if (pmId) {
          let pmIdxInTraineCSEs = this.trainedRegionCSEs.findIndex(
            (obj) => obj.Id == pmId
          );
          let pmIdxInTraineCSAs = this.trainedRegionCSAs.findIndex(
            (obj) => obj.Id == pmId
          );
          if (pmIdxInTraineCSEs == -1 && pmIdxInTraineCSAs == -1) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },

    filteredDowngradeOptions: function () {
      return this.downgradeOptions.RECOMMENDATION_FEEDBACK.filter((el) => {
        return el.enable == 1;
      });
    },
    filteredRequiredDates: function () {
      return this.downgradeOptions.RECOMMENDATION_FEEDBACK.filter((el) => {
        return el.date_required == 1 && el.enable == 1;
      });
    },

    submitButonDisabled() {
      //todo complete conditions!!!!
      console.log("submitButonDisabled");
      this.action; // this triggers reactivity when action changes
      this.primary_edit_assignments.Id;
      if (this.rating) {
        if (this.action == "approve") {
          // return true;
          if (
            this.primary_edit_assignments.Id !==
            this.getNewAssignCSEField("primary", "Id")
          ) {
            if (this.downgradeReasonPrimary.description) {
              if (
                this.downgradeReasonPrimary.description ==
                "Other (explained in comment box)"
              ) {
                if (this.prm_detailed_reason) {
                  return false;
                } else {
                  return true;
                }
              } else {
                return false;
              }
            } else {
              return true;
            }
          } else {
            return false;
          }
        } else if (this.action == "downgrade") {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    getPrimaryNewAssignName: function () {
      return this.getNewAssignCSEField("primary", "Name");
    },

    getSecondaryNewAssignName: function () {
      return this.getNewAssignCSEField("secondary", "Name");
    },

    getTertiaryNewAssignName: function () {
      return this.getNewAssignCSEField("tertiary", "Name");
    },

    getPMNewAssignName: function () {
      return this.getNewAssignCSEField("pm", "Name");
    },

    getPrimaryNewAssignTimeToTravel: function () {
      return this.getNewAssignCSETimeToTravel("primary");
    },

    getSecondaryNewAssignTimeToTravel: function () {
      return this.getNewAssignCSETimeToTravel("secondary");
    },

    getTertiaryNewAssignTimeToTravel: function () {
      return this.getNewAssignCSETimeToTravel("tertiary");
    },

    getPMNewAssignTimeToTravel: function () {
      return this.getNewAssignCSETimeToTravel("pm");
    },

    getPrimaryNewAssignUtil: function () {
      return this.getNewAssignCSEField("primary", "ResUtil_Heatmap");
    },

    getSecondaryNewAssignUtil: function () {
      return this.getNewAssignCSEField("secondary", "ResUtil_Heatmap");
    },

    getTertiaryNewAssignUtil: function () {
      return this.getNewAssignCSEField("tertiary", "ResUtil_Heatmap");
    },

    getPMNewAssignUtil: function () {
      return this.getNewAssignCSEField("pm", "ResUtil_Heatmap");
    },
  },
  methods: {
    ...mapActions(["pushNotification", "updateRecommendations"]),
    ...mapMutations(["setEditRecInProgress"]),
    getNewAssignCSEField(assignmentType, cseField) {
      let cseFieldToReturn = "";
      if (this.new_assignments.length !== 0) {
        let index = this.new_assignments.findIndex(
          (assignment) => assignment.AssignmentType === assignmentType
        );
        if (index !== -1) {
          const indexInCSE = this.cse_static.findIndex((obj) => {
            return obj.Id == this.new_assignments[index].CSEID;
          });
          if (indexInCSE !== -1) {
            cseFieldToReturn = this.cse_static[indexInCSE][cseField];
          } else {
            const indexInCSA = this.csa_static.findIndex((obj) => {
              return obj.Id == this.new_assignments[index].CSEID;
            });
            if (indexInCSA !== -1) {
              cseFieldToReturn = this.csa_static[indexInCSA][cseField];
            }
          }
        }
      }
      return cseFieldToReturn;
    },
    setAcceptRejRec(params) {
      if (params.e.target.active) {
        this.action = params.val;
      }
    },
    setPmSameAsPrimary(event) {
      // console.log(event);
      this.isPMSameAsPrimary = event.target.active;
      if (this.isPMSameAsPrimary) {
        this.pm_edit_assignments = { ...this.primary_edit_assignments };
      }
      //  else {
      //   this.pm_edit_assignments = { ...this.empty_edit_assignments };
      // }
    },
    closeModalAndClean() {
      this.closeModal();
      this.setSelectedRecommendation(this.selectedRecommandationIndex);
      this.downgradeReasonPrimary = { ...this.selectedDowngradeOptionEmpty };
      this.prm_detailed_reason = "";
    },
    closeModal() {
      document.querySelector("#assignments-modal").visible = false;
      this.dateObj = {};
    },

    setRating($event) {
      this.rating = $event;
    },

    setRecComment($event) {
      if ($event) {
        this.feedback = $event.target.value;
      } else {
        this.feedback = "";
      }
    },

    setSelectedRecommendation(indexOfSelected) {
      if (indexOfSelected === undefined) {
        this.action = "approve";
        this.description = "";
        this.new_assignments = [];
        this.rating = null;
        this.feedback = "";
        this.downgradeReasonPrimary = { ...this.selectedDowngradeOptionEmpty };
        // this.downgradeReasonSecondary = { ...this.selectedDowngradeOptionEmpty };
        // this.downgradeReasonTertiary = { ...this.selectedDowngradeOptionEmpty };
        // this.downgradeReasonPM = { ...this.selectedDowngradeOptionEmpty };
        this.status = "";
        this.summary = "";
        this.time = "";
        this.uid = "";
        this.primary_edit_assignments = { ...this.empty_edit_assignments };
        this.secondary_edit_assignments = { ...this.empty_edit_assignments };
        this.tertiary_edit_assignments = { ...this.empty_edit_assignments };
        this.pm_edit_assignments = { ...this.empty_edit_assignments };
        this.trainedRegionCSEs = [];
        this.rbdCompliantCSEs = [];
        this.untrainedRegionCSEs = [];
        this.trainedRegionCSAs = [];
        this.untrainedRegionCSAs = [];
        this.isPMSameAsPrimary = true;
      } else {
        this.action = "approve";
        this.description = this.filteredRecommend[indexOfSelected].description;
        this.new_assignments = [
          ...this.filteredRecommend[indexOfSelected].new_assignments,
        ];
        this.rating = this.filteredRecommend[indexOfSelected].rating;
        this.feedback = this.filteredRecommend[indexOfSelected].feedback;
        this.downgradeReasonPrimary = { ...this.selectedDowngradeOptionEmpty };
        // this.downgradeReasonPrimary = {
        //   ...this.filteredRecommend[indexOfSelected].selectedDowngradeOption,
        // }; //todo check this!!!!
        this.status = this.filteredRecommend[indexOfSelected].status;
        this.summary = this.filteredRecommend[indexOfSelected].summary;
        this.time = this.filteredRecommend[indexOfSelected].time;
        this.uid = this.filteredRecommend[indexOfSelected].uid;

        let prmIndex = this.new_assignments.findIndex(
          (assignment) => assignment.AssignmentType === "primary"
        );
        if (prmIndex !== -1) {
          const indexInCSE = this.cse_static.findIndex((obj) => {
            return obj.Id == this.new_assignments[prmIndex].CSEID;
          });
          if (indexInCSE !== -1) {
            this.primary_edit_assignments = {
              ...this.cse_static[indexInCSE],
              nameTravTimeResUtiliz:
                this.cse_static[indexInCSE].Name +
                " (" +
                this.findTimeToTravel(
                  this.new_assignments[prmIndex].FLID,
                  this.new_assignments[prmIndex].CSEID,
                  " hrs"
                ) +
                " / " +
                this.cse_static[indexInCSE].ResUtil_Heatmap +
                "%)",
            };
          } else {
            this.primary_edit_assignments = {
              ...this.empty_edit_assignments,
            };
          }
        } else {
          this.primary_edit_assignments = {
            ...this.empty_edit_assignments,
          };
        }

        let secIndex = this.new_assignments.findIndex(
          (assignment) => assignment.AssignmentType === "secondary"
        );
        if (secIndex !== -1) {
          const indexInCSE = this.cse_static.findIndex((obj) => {
            return obj.Id == this.new_assignments[secIndex].CSEID;
          });
          if (indexInCSE !== -1) {
            this.secondary_edit_assignments = {
              ...this.cse_static[indexInCSE],
              nameTravTimeResUtiliz:
                this.cse_static[indexInCSE].Name +
                " (" +
                this.findTimeToTravel(
                  this.new_assignments[secIndex].FLID,
                  this.new_assignments[secIndex].CSEID,
                  " hrs"
                ) +
                " / " +
                this.cse_static[indexInCSE].ResUtil_Heatmap +
                "%)",
            };
          } else {
            this.secondary_edit_assignments = {
              ...this.empty_edit_assignments,
            };
          }
        } else {
          this.secondary_edit_assignments = {
            ...this.empty_edit_assignments,
          };
        }

        let terIndex = this.new_assignments.findIndex(
          (assignment) => assignment.AssignmentType === "tertiary"
        );
        if (terIndex !== -1) {
          const indexInCSE = this.cse_static.findIndex((obj) => {
            return obj.Id == this.new_assignments[terIndex].CSEID;
          });
          if (indexInCSE !== -1) {
            this.tertiary_edit_assignments = {
              ...this.cse_static[indexInCSE],
              nameTravTimeResUtiliz:
                this.cse_static[indexInCSE].Name +
                " (" +
                this.findTimeToTravel(
                  this.new_assignments[terIndex].FLID,
                  this.new_assignments[terIndex].CSEID,
                  " hrs"
                ) +
                " / " +
                this.cse_static[indexInCSE].ResUtil_Heatmap +
                "%)",
            };
          } else {
            this.tertiary_edit_assignments = {
              ...this.empty_edit_assignments,
            };
          }
        } else {
          this.tertiary_edit_assignments = {
            ...this.empty_edit_assignments,
          };
        }

        let pmIndex = this.new_assignments.findIndex(
          (assignment) => assignment.AssignmentType === "pm"
        );
        if (pmIndex !== -1) {
          const indexInCSE = this.cse_static.findIndex((obj) => {
            return obj.Id == this.new_assignments[pmIndex].CSEID;
          });
          if (indexInCSE !== -1) {
            this.pm_edit_assignments = {
              ...this.cse_static[indexInCSE],
              nameTravTimeResUtiliz:
                this.cse_static[indexInCSE].Name +
                " (" +
                this.findTimeToTravel(
                  this.new_assignments[pmIndex].FLID,
                  this.new_assignments[pmIndex].CSEID,
                  " hrs"
                ) +
                " / " +
                this.cse_static[indexInCSE].ResUtil_Heatmap +
                "%)",
            };
          } else {
            const indexInCSA = this.csa_static.findIndex((obj) => {
              return obj.Id == this.new_assignments[pmIndex].CSEID;
            });
            if (indexInCSA !== -1) {
              this.pm_edit_assignments = {
                ...this.csa_static[indexInCSA],
                nameTravTimeResUtiliz:
                  this.csa_static[indexInCSA].Name +
                  " (" +
                  this.findTimeToTravel(
                    this.new_assignments[pmIndex].FLID,
                    this.new_assignments[pmIndex].CSEID,
                    " hrs"
                  ) +
                  " / " +
                  this.csa_static[indexInCSA].ResUtil_Heatmap +
                  "%)",
              };
            } else {
              this.pm_edit_assignments = {
                ...this.empty_edit_assignments,
              };
            }
          }
        } else {
          this.pm_edit_assignments = {
            ...this.empty_edit_assignments,
          };
        }

        if (this.pm_edit_assignments.Id == this.primary_edit_assignments.Id) {
          this.isPMSameAsPrimary = true;
        } else {
          this.isPMSameAsPrimary = false;
        }

        this.getTrainedUntrainedCSEsCSAs();
      }
    },

    getTrainedUntrainedCSEsCSAs() {
      let flIndex = this.fl_static.findIndex(
        (obj) => obj.Id == this.new_assignments[0].FLID
      );
      if (flIndex !== -1) {
        let regionCSEs = this.cse_static
          .filter((cse) => cse.RegionID == this.fl_static[flIndex].RegionID)
          .map((cse) => {
            return {
              ...cse,
              trainedForFL: this.fl_static[flIndex].Qualified_CSEs.includes(
                cse.Id
              )
                ? true
                : false,
              rbdCompliantForFL: this.fl_static[
                flIndex
              ].RBD_Compliant_CSEs.includes(cse.Id)
                ? true
                : false,
              timeToTravel: this.findTimeToTravel(
                this.fl_static[flIndex].Id,
                cse.Id,
                " hrs"
              ),
              timeToTravelAsNumber: parseFloat(
                this.findTimeToTravel(this.fl_static[flIndex].Id, cse.Id, "")
              ),
              nameTravTimeResUtiliz:
                cse.Name +
                " (" +
                this.findTimeToTravel(
                  this.fl_static[flIndex].Id,
                  cse.Id,
                  " hrs"
                ) +
                " / " +
                cse.ResUtil_Heatmap +
                "%)",
            };
          })
          .sort((a, b) => {
            return a.timeToTravelAsNumber - b.timeToTravelAsNumber;
          });
        this.trainedRegionCSEs = regionCSEs.filter((cse) => cse.trainedForFL);
        this.rbdCompliantCSEs = regionCSEs.filter(
          (cse) => cse.rbdCompliantForFL
        );
        this.untrainedRegionCSEs = regionCSEs.filter((cse) => {
          return !cse.trainedForFL && !cse.rbdCompliantForFL;
        });

        let regionCSAs = this.csa_static
          .map((csa) => {
            return {
              ...csa,
              trainedForFL: this.fl_static[flIndex].Qualified_CSAs.includes(
                csa.Id
              )
                ? true
                : false,
              timeToTravel: this.findTimeToTravel(
                this.fl_static[flIndex].Id,
                csa.Id,
                " hrs"
              ),
              timeToTravelAsNumber: parseFloat(
                this.findTimeToTravel(this.fl_static[flIndex].Id, csa.Id, "")
              ),
              nameTravTimeResUtiliz:
                csa.Name +
                " (" +
                this.findTimeToTravel(
                  this.fl_static[flIndex].Id,
                  csa.Id,
                  " hrs"
                ) +
                " / " +
                csa.ResUtil_Heatmap +
                "%)",
            };
          })
          .sort((a, b) => {
            return a.timeToTravelAsNumber - b.timeToTravelAsNumber;
          });
        this.trainedRegionCSAs = regionCSAs.filter((csa) => csa.trainedForFL);
        this.untrainedRegionCSAs = regionCSAs.filter(
          (csa) => !csa.trainedForFL
        );
      }
    },

    getFLProperty(property) {
      let propertyValue = "";
      if (this.new_assignments.length !== 0) {
        const indexInFL = this.fl_static.findIndex((obj) => {
          return obj.Id == this.new_assignments[0].FLID;
        });
        if (indexInFL !== -1) {
          propertyValue = this.fl_static[indexInFL][property];
        }
      }
      return propertyValue;
    },

    getAssignedCSEField(cseRole, flId, cseField) {
      let cseName = "";

      const fl_cse = this.fl_cse_conn_obj[flId];

      if (fl_cse) {
        const indexInCSE = this.cse_static.findIndex((obj) => {
          return obj.Id == fl_cse[cseRole];
        });
        if (indexInCSE !== -1) {
          cseName = this.cse_static[indexInCSE][cseField];
        }
      }
      return cseName;
    },

    getAssignedIdForRole(cseRole) {
      let cseId = "";
      if (this.new_assignments.length !== 0) {
        const fl_cse = this.fl_cse_conn_obj[this.new_assignments[0].FLID];
        if (fl_cse) {
          cseId = fl_cse[cseRole];
        }
      }
      return cseId;
    },

    getAssignedRoleName(cseRole, getNameMethod, getFieldMethod) {
      let assignedRoleId = this.getAssignedIdForRole(cseRole);
      let assignedRoleName = getNameMethod(cseRole, "Name", getFieldMethod);

      if (assignedRoleId) {
        if (assignedRoleName) {
          return assignedRoleName;
        } else {
          return (
            "External to the region (" + this.getFLProperty("RegionID") + ")"
          );
        }
      } else {
        return "";
      }
    },

    callGetAssignedField(cseRole, cseField, getAssignedField) {
      if (this.new_assignments.length !== 0) {
        return getAssignedField(
          cseRole,
          this.new_assignments[0].FLID,
          cseField
        );
      } else {
        return "";
      }
    },

    getAssignedCSEorCSAfield(label, flId, cseField) {
      let cseName = "";

      const fl_cse = this.fl_cse_conn_obj[flId];

      if (fl_cse) {
        const indexInCSE = this.cse_static.findIndex((obj) => {
          return obj.Id == fl_cse[label];
        });

        if (indexInCSE !== -1) {
          cseName = this.cse_static[indexInCSE][cseField];
        } else {
          const indexInCSA = this.csa_static.findIndex((obj) => {
            return obj.Id == fl_cse[label];
          });
          if (indexInCSA !== -1) {
            cseName = this.csa_static[indexInCSA][cseField];
          }
        }
      }
      return cseName;
    },
    findTimeToTravelByCSELabel(assignType) {
      if (this.new_assignments.length !== 0) {
        const fl_cse = this.fl_cse_conn_obj[this.new_assignments[0].FLID];
        if (fl_cse) {
          let timeToTrav = this.findTimeToTravel(
            this.new_assignments[0].FLID,
            fl_cse[assignType],
            " hrs"
          );
          return timeToTrav;
        }
      }
      return "";
    },

    getNewAssignCSETimeToTravel(assignmentType) {
      if (this.new_assignments.length !== 0) {
        const fl_cse = this.fl_cse_conn_obj[this.new_assignments[0].FLID];
        if (fl_cse) {
          let index = this.new_assignments.findIndex(
            (assignment) => assignment.AssignmentType === assignmentType
          );
          if (index !== -1) {
            let timeToTrav = this.findTimeToTravel(
              this.new_assignments[0].FLID,
              this.new_assignments[index].CSEID,
              " hrs"
            );
            return timeToTrav;
          }
        }
      }
      return "";
    },

    findTimeToTravel(flId, cseId, unitMeasure = " hours") {
      let time = "";

      if (this.selecteddivision == "ImagingZone") {
        if (this.zone_travel_time_map[cseId]) {
          let traveTimes = this.zone_travel_time_map[cseId];
          if (traveTimes[flId]) {
            time = traveTimes[flId] + unitMeasure;
          }
        }
      } else {
        if (this.travel_time_map[cseId]) {
          let traveTimes = this.travel_time_map[cseId];
          if (traveTimes[flId]) {
            time = traveTimes[flId] + unitMeasure;
          }
        }
      }

      return time;
    },

    blockEvent() {
      return;
    },

    isCSEprimaryListItemActive(item) {
      return item.Id == this.primary_edit_assignments.Id;
    },

    isCSEsecondaryListItemActive(item) {
      return item.Id == this.secondary_edit_assignments.Id;
    },

    isCSEtertiaryListItemActive(item) {
      return item.Id == this.tertiary_edit_assignments.Id;
    },

    isPmListItemActive(item) {
      return item.Id == this.pm_edit_assignments.Id;
    },

    isListItemRecommended(item, assignment) {
      if (this.new_assignments.length) {
        let assignIndex = this.new_assignments.findIndex(
          (newAssign) => newAssign.AssignmentType === assignment
        );
        if (assignIndex !== -1) {
          if (this.new_assignments[assignIndex].CSEID == item.Id) return true;
          else return false;
        } else return false;
      } else return false;
    },

    // isCSEprimaryListItemDisabled(item) {
    //   if (this.new_assignments.length) {
    //     return (
    //       item.Id ==
    //       this.getAssignedCSEField(
    //         "PrimaryCSEID",
    //         this.new_assignments[0].FLID,
    //         "Id"
    //       )
    //     );
    //   } else return true;
    // },

    // isCSEsecondaryListItemDisabled(item) {
    //   if (this.new_assignments.length) {
    //     return (
    //       item.Id ==
    //       this.getAssignedCSEField(
    //         "SecondaryCSEID",
    //         this.new_assignments[0].FLID,
    //         "Id"
    //       )
    //     );
    //   } else return true;
    // },

    // isCSEtertiaryListItemDisabled(item) {
    //   if (this.new_assignments.length) {
    //     return (
    //       item.Id ==
    //       this.getAssignedCSEField(
    //         "TertiaryCSEID",
    //         this.new_assignments[0].FLID,
    //         "Id"
    //       )
    //     );
    //   } else return true;
    // },

    // isPmListItemDisabled(item) {
    //   if (this.new_assignments.length !== 0) {
    //     return (
    //       item.Id ==
    //       this.getAssignedCSEorCSAfield(
    //         "PMCSEID",
    //         this.new_assignments[0].FLID,
    //         "Id"
    //       )
    //     );
    //   } else {
    //     return true;
    //   }
    // },

    callSetSelectedPrimary(cse) {
      this.primary_edit_assignments = { ...cse };

      if (this.isPMSameAsPrimary) {
        this.pm_edit_assignments = { ...this.primary_edit_assignments };
      }
    },
    callSetSelectedSecondary(cse) {
      this.secondary_edit_assignments = { ...cse };
    },

    callSetSelectedTertiary(cse) {
      this.tertiary_edit_assignments = { ...cse };
    },

    callSetSelectedPM(cseCsa) {
      this.pm_edit_assignments = {
        ...cseCsa,
      };

      if (this.pm_edit_assignments.Id == this.primary_edit_assignments.Id) {
        this.isPMSameAsPrimary = true;
      } else {
        this.isPMSameAsPrimary = false;
      }
    },

    setDowngradeOptionPrimary(index) {
      this.downgradeReasonPrimary = {
        ...this.filteredDowngradeOptions[index],
      };
    },

    changeCSEPreferenceObj($event, dateLabel) {
      console.log($event, dateLabel);
      if (this.new_assignments.length) {
        let dateFromEvent = $event.target.value;
        console.log("dateFromEvent ", dateFromEvent);
        if (typeof dateFromEvent == "string") {
          if (this.dateObj[dateLabel] !== dateFromEvent) {
            let payload = {
              username: this.oidcUser ? this.oidcUser.email : "",
              [dateLabel]: dateFromEvent ? dateFromEvent : null,
            };
            let prmIndex = this.new_assignments.findIndex(
              (assignment) => assignment.AssignmentType === "primary"
            );
            if (prmIndex !== -1) {
              this.sendCsePreference(
                payload,
                this.new_assignments[prmIndex].CSEID
              );
            }
          }
        } else if (typeof dateFromEvent == "undefined") {
          this.dateObj[dateLabel] = undefined;
        } else if (dateFromEvent === null) {
          this.dateObj[dateLabel] = null;
        }
      }
    },

    sendCsePreference(payload, cseId) {
      axios
        .post(
          this.backendURL +
            "/api/cse_preference/" +
            this.selectedCountry.iso_3166_1 +
            "/" +
            cseId,
          payload
        )
        .then((res) => {
          console.log("CSE preference sent to backend ", res.data);
          this.dateObj = { ...res.data };
        })
        .catch((err) => {
          console.log(err);
          let notification = {
            type: "warning",
            label: "Back to Work Error",
            duration: "short",
            text: "Back to Work date was not submitted!",
          };
          this.pushNotification(notification);
        });
    },

    setPrmDetailReason($event) {
      // console.log($event);
      if ($event) {
        this.prm_detailed_reason = $event.target.value;
      } else {
        this.prm_detailed_reason = "";
      }
    },

    submitSelectedRecommend() {
      this.submitSelectedRecommendation(this.$route.params.area);
      this.closeModal();
    },

    getCurrentDate() {
      var m = new Date();
      var dateString =
        m.getUTCFullYear() +
        "/" +
        ("0" + (m.getUTCMonth() + 1)).slice(-2) +
        "/" +
        ("0" + m.getUTCDate()).slice(-2) +
        " " +
        ("0" + m.getUTCHours()).slice(-2) +
        ":" +
        ("0" + m.getUTCMinutes()).slice(-2) +
        ":" +
        ("0" + m.getUTCSeconds()).slice(-2);
      return dateString;
    },

    async submitSelectedRecommendation(
      // { rootGetters, getters, commit, dispatch },
      area
    ) {
      this.setEditRecInProgress(true);
      //todo check payload for accepted or rejected
      let payload = {};
      if (this.action == "approve") {
        payload = {
          uid: this.uid,
          username: this.oidcUser ? this.oidcUser.email : "",
          time: this.getCurrentDate(),

          status: this.status,
          rating: this.rating, //there is no rating requested when dowgrading
          feedback: this.feedback,
          new_assignments: this.new_assignments,
          edit_assignments: [],
          action: this.action,
        };

        if (this.primary_edit_assignments.Id) {
          if (this.new_assignments.length) {
            let prmPayload = {
              AssignmentType: "primary",
              CSEID: this.primary_edit_assignments.Id,
              FLID: this.new_assignments[0].FLID,
              reason_for_change: "",
              detailed_reason: "",
            };

            let prmIndex = this.new_assignments.findIndex(
              (assignment) => assignment.AssignmentType === "primary"
            );
            if (prmIndex !== -1) {
              if (
                this.new_assignments[prmIndex].CSEID !==
                this.primary_edit_assignments.Id
              ) {
                prmPayload.reason_for_change =
                  this.downgradeReasonPrimary.description;
                if (
                  this.downgradeReasonPrimary.description ==
                  "Other (explained in comment box)"
                ) {
                  prmPayload.detailed_reason = this.prm_detailed_reason;
                }
              }
            }
            payload.edit_assignments.push(prmPayload);
          }
        }

        if (this.secondary_edit_assignments.Id) {
          if (this.new_assignments.length) {
            payload.edit_assignments.push({
              AssignmentType: "secondary",
              CSEID: this.secondary_edit_assignments.Id,
              FLID: this.new_assignments[0].FLID,
              reason_for_change: "",
              detailed_reason: "",
            });
          }
        }

        if (this.tertiary_edit_assignments.Id) {
          if (this.new_assignments.length) {
            payload.edit_assignments.push({
              AssignmentType: "tertiary",
              CSEID: this.tertiary_edit_assignments.Id,
              FLID: this.new_assignments[0].FLID,
              reason_for_change: "",
              detailed_reason: "",
            });
          }
        }

        if (this.pm_edit_assignments.Id) {
          if (this.new_assignments.length) {
            payload.edit_assignments.push({
              AssignmentType: "pm",
              CSEID: this.pm_edit_assignments.Id,
              FLID: this.new_assignments[0].FLID,
              reason_for_change: "",
              detailed_reason: "",
            });
          }
        }
      } else if (this.action == "downgrade") {
        payload = {
          uid: this.uid,
          status: this.status,
          action: this.action,
          username: this.oidcUser ? this.oidcUser.email : "",
          time: this.getCurrentDate(),
          rating: this.rating, //there is no rating requested when dowgrading
          feedback: this.feedback,
          // todo check if new_assignments is needed
        };
      }

      // console.log(area, payload);
      let reqStr = "";
      if (this.selecteddivision == "ImagingZone") {
        reqStr =
          this.backendURL +
          "/api/service_zone_current_data/recommendation_feedback_new/" +
          this.selectedCountry.iso_3166_1 +
          "/" +
          area;
      } else {
        reqStr =
          this.backendURL +
          "/api/service_current_data/recommendation_feedback_new/" +
          this.selectedCountry.iso_3166_1 +
          "/" +
          area;
      }
      try {
        const res = await axios.post(reqStr, payload);
        // console.log("******************************** dgrade opts ", res.data);
        this.updateRecommendations(res.data);

        this.updateSelectedRecomendation(res.data); // todo check this
        this.setEditRecInProgress(false);
      } catch (err) {
        console.log(err);
        this.setEditRecInProgress(false);

        this.pushNotification({
          type: "error",
          label: "Submit Recommendations error",
          text: "Recommendation could not be submitted",
        });
      }
    },

    updateSelectedRecomendation(updates) {
      //todo check this
      if (this.uid) {
        let index = updates.findIndex((upd) => upd.uid === this.uid);

        if (index !== -1) {
          this.feedback = updates[index].feedback;
          this.status = updates[index].status;
          this.rating = updates[index].rating;
          this.time = updates[index].time;

          // console.log(Object.keys(updates[index]));
        }
      }
    },

    async getCSERetirementReturnDates() {
      //todo change with new_assignments primary; get the primary cse
      if (this.new_assignments.length) {
        let prmIndex = this.new_assignments.findIndex(
          (assignment) => assignment.AssignmentType === "primary"
        );
        if (prmIndex !== -1) {
          try {
            const res = await axios.get(
              this.backendURL +
                "/api/cse_preference/" +
                this.selectedCountry.iso_3166_1 +
                "/" +
                this.new_assignments[prmIndex].CSEID
            );
            console.log(res.data);
            this.dateObj = { ...res.data };
          } catch (err) {
            console.log(err);
            let notification = {
              type: "error",
              label: "Retirement date error",
              // duration: "short",
              text: "Error wile loading Retirement date!",
            };
            this.pushNotification(notification);
          }
        }
      }
    },
  },
  watch: {
    selectedRecommandationIndex: function (val) {
      this.setSelectedRecommendation(val);
    },
  },
};
</script>
<style scoped lang="scss">
.buttonsFooter {
  float: right;
}

.verticalCenterFlex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
}
.verticalCenterAbsolute {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.diffrentRecCSE {
  background-color: #fdefe5;
}
</style>
